import { date, number } from 'yup';

import { isCyclesAvailable, isLandingsAvailable } from 'src/core/state';

export const getInitialSchema = () => ({
  isLandingsAvailable: false,
  isCyclesAvailable: false,
});

const wrapRequired = (isRequired, validator) => {
  if (isRequired) {
    validator = validator.required();
  } else {
    validator = validator.notRequired().nullable();
  }
  return validator;
};

export const getValidationSchema = (prefix, required = true) => ({
  [`${prefix}date`]: wrapRequired(required, date()),
  [`${prefix}hours`]: wrapRequired(required, number().min(0)),
  [`${prefix}landings`]: number().min(0).when('isLandingsAvailable', {
    is: true,
    then: schema => wrapRequired(required, schema.required()),
    otherwise: schema => schema.nullable(),
  }),
  [`${prefix}cycles`]: wrapRequired(required, number().min(0).when('isCyclesAvailable', {
    is: true,
    then: schema => wrapRequired(required, schema.required()),
    otherwise: schema => schema.nullable(),
  })),
});

export const updateFormStateFields = (form, type) => {
  form.isLandingsAvailable = isLandingsAvailable(type);
  form.isCyclesAvailable = isCyclesAvailable(type);
};

export const createStateChangeHandler = handler => ({ detail: val }) => handler(val.fieldName, val.value);
